module.exports = new __parcel__URL__("sam-meyer-portrait.085aa2d2.jpg").toString();